import { TabPanel } from '@mui/lab'
import React, { Component } from 'react'
import { SUPPORT_TAB } from '../SupportOverview'
import { Typography } from '@mui/material'
import SupportCaseButton from '../Elements/SupportCaseButton'
import { connect } from 'react-redux'

export class AllSupportCasesTabContent extends Component {
    render() {
        return (
            <TabPanel value={SUPPORT_TAB.ALL.toString()}>
                <Typography>Alle Supportfälle</Typography>
                <div style={{ display:"flex", flexWrap:"wrap", justifyContent:"center", marginTop:"2.5%"}}>
                    {this.props.caseList?.map(item => {
                        return <SupportCaseButton key={"SupporCaseBtn_AllSupportCases_"+item.id} id={item.id} data={item}></SupportCaseButton>
                    })}
                </div>
            </TabPanel>
        )
    }
}
function mapStateToProps(state) {
    return {
        caseList: state.support.allCaseList
    }
}
export default connect(mapStateToProps)(AllSupportCasesTabContent);